export default __webpack_public_path__ + "static/media/CLASICAS.18ff35d4.png";